export const HEALTHY = 'healthy';
export const UNHEALTHY = 'unhealthy';
export const UNAUTHENTICATED = 'unauthenticated';
